const Random = {
  get() {
    const thisDate = new Date('2017-11-03'.replace(/-/g, '/'));
    const thatDate = new Date();
    const millisecond = thatDate.getTime() - thisDate.getTime();
    const diffDay = parseInt((millisecond < 0 ? 0 : millisecond) / (1000 * 60 * 60 * 24), 10);

    return 100 + (diffDay * 45);
  },
};
export default Random;



// WEBPACK FOOTER //
// ./src/utils/Random/index.js